import {
  Action,
  RequestTimeOffResponse as Response,
  TimeOffEvent,
  TimeOffQueryParams,
  convertTimeOffEvent,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import scheduleKeys from 'schedule/queries/shared/keys'
import { performAction } from 'shared/queries/perform_action'
import keys from './shared/keys'

type Variables = Action

// FIXME: make queryParam a required parameter so we can update cache properly

export function usePerformTimeOffAction(queryParams?: TimeOffQueryParams) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateTimeOffRequest,
    onSuccess: async data => {
      if (data && queryParams) {
        const key = keys.detail(queryParams)

        if (client.getQueryData<TimeOffEvent>(key)) {
          await client.cancelQueries({ queryKey: key })
          client.setQueryData<TimeOffEvent>(key, data)
        }
      }

      client.invalidateQueries({ queryKey: keys.all }).catch(() => null)
      client.invalidateQueries({ queryKey: scheduleKeys.all }).catch(() => null)
    },
  })

  async function mutateTimeOffRequest(
    action: Variables
  ): Promise<TimeOffEvent | null> {
    const response = await performAction<Response.TimeOffEvent>(server, action)
    return response ? convertTimeOffEvent(response) : null
  }
}
